import { render, staticRenderFns } from "./ViewDepartmentPage.vue?vue&type=template&id=410b6d0a&"
import script from "./ViewDepartmentPage.vue?vue&type=script&lang=js&"
export * from "./ViewDepartmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports